import { useNavigate } from 'react-router-dom';
import Loginheader from '../Loginheader';
import Menu from '../Menu';
import $ from 'jquery';
import * as Common from '../Common';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import Dialog from '../Dialog';
function Master_Entity_Location() {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);
    const [userRight, setUserRight] = useState([]);
    // const [showAddDiv, setShowAddDiv] = useState(false);
    // const [ddReqIsdOptions, setDdReqIsdOptions] = useState([]);
    const [agentLocList, setAgentLocList] = useState([]);
    const [agent, setAgent] = useState(JSON.stringify({ value: "0", name: "Select" }));
    const [location, setLocation] = useState('');
    const [status, setStatus] = useState("1");
    const [locationSrno, setLocationSrno] = useState(0)
    const [msgText, setMsgText] = useState("")
    const [isMsgBox, setMsgBox] = useState(false)

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiEntity, [sid, 'ddlistjson', 'A'], function (result) {
                setDdReqAgentOptions(JSON.parse(result));
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'ENTITYLOCATION'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function getList() {
        console.log(!!JSON.parse(agent).value)
        if (JSON.parse(agent).value != 0) {
            $('.loader').show();
            console.log('in if')
            Common.callApi(Common.apiEntityLocation, [sid, 'list', JSON.parse(agent).value], function (result) {
                $('.loader').hide();
                setAgentLocList(JSON.parse(result));
                setLocationSrno(0);
                setLocation("")
                setStatus("1")
            });
        }
        else {
            $('.loader').hide();
            console.log('in else')
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(["Please select Agent"]))
        }
    }

    function editBtnHandler(obj) {
        console.log(obj)
        setLocationSrno(obj.mel_srno);
        setLocation(obj.mel_location);
        setStatus(obj.mel_active);
    }
    function addBtnHandler() {
        $('.loader').show();
        let i = 0;
        let msg = [];
        console.log(JSON.parse(agent).value == 0, !location.trim(), status === "")
        if (JSON.parse(agent).value == 0 || !location.trim() || status === "") {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (JSON.parse(agent).value == 0 ? 'Agent' : '');
            msg[i++] = (!location.trim() ? 'Location.' : '');
            msg[i++] = (!status ? 'Status' : '');
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
            $('.loader').hide();
        } else {
            let obj = {
                locationSrno: locationSrno,
                agentId: JSON.parse(agent).value,
                location: location,
                status: status
            }
            Common.callApi(Common.apiEntityLocation, [sid, 'addNewLocation', JSON.stringify(obj)], function (result) {
                $('.loader').hide();
                getList();
                cancelBtnHandler()
            });
        }
    }


    function cancelBtnHandler() {
        setLocationSrno(0);
        setLocation("")
        setStatus("")
    }


    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                {/* heading */}
                <Row>
                    <Col>
                        <h1>Entity Location</h1>
                    </Col>
                </Row>
                {/* list filter  */}
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                            <Form.Select
                                value={agent?.name}
                                onChange={(e) => { setAgent(e.target.value) }} >
                                {ddReqAgentOptions.map((res) =>
                                    <option key={res.value} value={JSON.stringify(res)}>{res.name}</option>
                                )}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col><Button style={{ marginTop: '32px' }} onClick={getList}>List</Button></Col>
                    <Col>&nbsp;</Col>
                </Row>
                <Row>&nbsp;</Row>
                {/* <Row>&nbsp;</Row> */}
                {/* add handler  */}

                {userRight.add === "1" && <Row>

                    <Col>
                        <Form.Group>
                            <Form.Label>Location<span className="mandatory">*</span></Form.Label>
                            <Form.Control type="text" placeholder='Location' value={location} maxLength="100" onChange={(e) => setLocation(e.target.value)} ></Form.Control>
                        </Form.Group>
                    </Col>
                    <Col>

                        <Form.Group>
                            <Form.Label>Status<span className="mandatory">*</span></Form.Label>
                            <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}    >
                                <option value="">Select</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </Form.Select>
                        </Form.Group>

                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>&nbsp;</Form.Label><br></br>
                            {locationSrno == 0 ?
                                <Button onClick={addBtnHandler}>Add</Button> :
                                <>
                                    <Button onClick={addBtnHandler}>Submit</Button> &nbsp;
                                    <Button onClick={cancelBtnHandler}>Cancel</Button>
                                </>
                            }
                        </Form.Group>
                    </Col>
                    <Col>&nbsp;</Col>

                </Row>}
                <Row>&nbsp;</Row>
                {/* list  */}
                <Row>
                    <Col>
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    {userRight.edit === "1" ? <th></th> : null}
                                    <th className="textCenter" >Location</th>
                                    <th className="textCenter">Status</th>
                                </tr>
                            </thead>
                            <tbody id="tblBody">
                                {agentLocList.map((res) =>
                                    <tr key={res.mel_srno}>
                                        {userRight.edit === "1" ?
                                            <td className="textCenter" >{res.mel_srno} &nbsp;
                                                <span className="handCursor" >
                                                    <span className="colorThemeBlue" onClick={() => editBtnHandler(res)} >
                                                        &nbsp;<FontAwesomeIcon icon={faEdit} /></span>
                                                </span>
                                            </td>
                                            : null
                                        }
                                        <td className="textCenter">{res.mel_location}</td>
                                        <td className="textCenter">{res.mel_active == "1" ? 'Active' : 'Inactive'}</td>
                                    </tr>
                                )}
                                <tr>&nbsp;</tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>

                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </Container>
        </>
    )
}
export default Master_Entity_Location;